import { rest } from 'msw'
import { coreApiBase, Resolver } from 'test-utils/mock-api'

export const mockOif = (resolver: Resolver) => {
  return rest.get(
    `${coreApiBase}/oif`,
    resolver
  )
}

const mock200: Resolver = (_req, res, ctx) => {
  return res(
    ctx.status(200)
  )
}

const mock500: Resolver = (_req, res, ctx) => {
  return res(
    ctx.status(500)
  )
}

const mockSlowResponse: Resolver = async (_req, res, ctx) => {
  return res(
    ctx.delay(1000),
    ctx.status(200)
  )
}

export const mockOifResolvers = {
  mock200,
  mock500,
  mockSlowResponse
}
